module.exports = __webpack_public_path__ + "static/media/report-patient.6973fd88.png";